import {
  HouseType,
  RoofType,
} from "Components/Features/CheckPrice/Products/RiskProducts/HouseProducts/House/houseTypes";
import { EntityType, ErrorState } from "Store/interfaces/products";

export type EstateState = {
  estateInformation: EstateInformationEntity;
  ownedEstateInformation: EstateInformationEntity;
  ownedEstates: OwnedEstatesEntity;
};

export type EstateInformationEntity = EntityType<
  EstateInformation,
  OperationType
>;
export type OwnedEstatesEntity = EntityType<EstateIdentity[], OperationType>;

export type EstateError = ErrorState<OperationType>;

export enum SimpleHouseType {
  DETACHED_HOUSE = "DETACHED_HOUSE",
  UNDETACHED_HOUSE = "UNDETACHED_HOUSE",
  SEMI_DETACHED_HOUSE = "SEMI_DETACHED_HOUSE",
  AGRICULTURAL = "AGRICULTURAL",
  OTHER = "OTHER",
}

export interface EstateIdentity {
  readonly cadastre: Cadastre;
  readonly municipality: string;
  readonly postCode?: string;
  readonly postCodeName?: string;
  readonly streetAddress?: string;
  readonly isRegisteredAddress: boolean;
  readonly simpleHouseType: SimpleHouseType;
}

export interface EstateInformation {
  readonly identity: EstateIdentity;
  readonly buildYear?: string;
  readonly grossArea?: number;
  readonly estimatedGrossArea?: number;
  readonly houseType?: HouseType;
  readonly roofType?: RoofType;
  readonly usableArea?: number;
  readonly hasBasement?: boolean;
  readonly hasFloodRisk?: boolean;
  readonly customerErrors?: EstateUwReason[];
  readonly buildings?: EstateAdditionalBuilding[];
}

export enum EstateAdditionalBuildingType {
  GARAGE_OUTHOUSE_ANNEX = "GARAGE_OUTHOUSE_ANNEX",
  FARMHOUSE = "FARMHOUSE",
  OTHER_AGRICULTURAL = "OTHER_AGRICULTURAL",
  HOUSE_FOR_ANIMALS_AGRICULTURAL_STORAGE_SILO = "HOUSE_FOR_ANIMALS_AGRICULTURAL_STORAGE_SILO",
  OTHER = "OTHER",
}

export interface EstateAdditionalBuilding {
  readonly buildingId: string;
  readonly grossArea: number;
  readonly buildYear: string;
  readonly type: EstateAdditionalBuildingType;
  readonly status: AdditionalBuildingStatusType;
}

export enum AdditionalBuildingStatusType {
  IN_USE = "IN_USE",
  OTHER = "OTHER",
}

export interface Cadastre {
  readonly bNr: number;
  readonly fNr: number;
  readonly gNr: number;
  readonly kNr: number;
  readonly sNr: number;
}

export enum OperationType {
  GET_ESTATE,
  GET_OWNED_ESTATE,
  GET_OWNED_ESTATES,
}

export enum EstateUwReason {
  UW_NEEDED = "UW_NEEDED",
  UW_NEEDED_UNITS = "UW_NEEDED_UNITS",
}

export enum EstateErrorCode {
  NO_VALID_HOUSE = "NO_VALID_HOUSE",
}
